import { FaChevronDown } from 'react-icons/fa6';
import { AnimatePresence, motion } from 'framer-motion';
import type { MouseEvent, ReactNode } from 'react';

interface CategoryAccordionProps {
  id: string | number;
  title: string;
  isExpanded: boolean;
  toggleExpanded: (event: MouseEvent) => void;
  children: ReactNode;
}

function CategoryAccordion({ id, title, isExpanded, toggleExpanded, children }: CategoryAccordionProps) {
  const accordionId = `filter-group-${id}`;

  return (
    <div key={`group-${id}`} data-cy='category-accordion'>
      <button
        aria-expanded={isExpanded}
        aria-controls={accordionId}
        onClick={toggleExpanded}
        className='w-full text-left p-4 py-2.5 bg-[#ECECEC] font-bold text-base'
      >
        {title}
        <FaChevronDown
          size={16}
          className={`float-right transition-all duration-500 ${isExpanded ? 'scale-y-[-1] mt-1' : 'scale-y-[1]'}`}
        />
      </button>

      <AnimatePresence initial={false}>
        {isExpanded && (
          <motion.div
            id={accordionId}
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3 }}
            className='bg-white w-full text-left overflow-hidden'
          >
            {children}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

export default CategoryAccordion;
